export const initSlider = (slider) => {
    const container = slider.querySelector('.js-slider-container');
    const track = slider.querySelector('.js-slider-track');
    const triggers = [...slider.querySelectorAll('.js-slider-trigger')];

    let current = 0;
    let size = track.childElementCount;
    let slidesInView = 1;
    let navigationNeeded = false;

    const touch = {
        startX: 0, endX: 0,
        startY: 0, endY: 0,
    };

    const checkNavigationNeeded = () => {
        if (track.children.length === 0) {
            navigationNeeded = false;
            return;
        }

        // Bereken hoeveel slides er zichtbaar zijn
        const containerWidth = container.clientWidth;
        const slideWidth = track.firstElementChild.clientWidth;
        slidesInView = Math.floor(containerWidth / slideWidth);

        // Navigatie is nodig als er meer slides zijn dan er zichtbaar zijn
        navigationNeeded = track.children.length > slidesInView;

        // Update de werkelijke size voor navigatie
        size = Math.max(1, track.children.length - slidesInView + 1);
    };

    const updateTriggerVisibility = () => {
        triggers.forEach((trigger) => {
            if (navigationNeeded) {
                // Toon navigation triggers alleen als navigatie nodig is
                if (trigger.hasAttribute('data-prev') || trigger.hasAttribute('data-next')) {
                    trigger.classList.remove('d-none');
                }
                // Toon dot indicators alleen als er meer dan 1 pagina is
                else if (trigger.hasAttribute('data-index')) {
                    if (size > 1) {
                        trigger.classList.remove('d-none');
                    } else {
                        trigger.classList.add('d-none');
                    }
                }
                // Andere triggers (zoals counter)
                else {
                    trigger.classList.remove('d-none');
                }
            } else {
                // Verberg alle triggers als navigatie niet nodig is
                trigger.classList.add('d-none');
            }
        });
    };

    const goToSlide = (index) => {
        if(index < 0) {
            index = 0;
        }

        if(index > (size - 1)) {
            index = (size - 1);
        }

        current = index;
        track.style.setProperty('--x', current);

        updateTriggerStates();
    };

    const toPrevious = () => {
        if(current > 0) {
            goToSlide(current - 1);
        }
    };

    const toNext = () => {
        if(current < size - 1) {
            goToSlide(current + 1);
        }
    };

    const touchStartHandler = (e) => {
        // Alleen touch handling als navigatie nodig is
        if (!navigationNeeded) return;

        touch.startX = e.changedTouches[0].screenX;
        touch.startY = e.changedTouches[0].screenY;

        document.addEventListener('touchend', touchEndHandler);
    };

    const touchEndHandler = (e) => {
        touch.endX = e.changedTouches[0].screenX;
        touch.endY = e.changedTouches[0].screenY;

        const xDiff = Math.abs(touch.startX - touch.endX);
        const yDiff = Math.abs(touch.startY - touch.endY);

        if(xDiff > yDiff) {
            if(touch.endX > touch.startX) {
                toPrevious();
            } else if(touch.endX < touch.startX) {
                toNext();
            }
        }

        document.removeEventListener('touchend', touchEndHandler);
    };

    const updateTriggerStates = () => {
        triggers.forEach((trigger) => {
            let isDisabled = false;
            let isCurrent = false;

            if(trigger.hasAttribute('data-prev') && current === 0) {
                isDisabled = true;
            }

            if(trigger.hasAttribute('data-next') && current === size - 1) {
                isDisabled = true;
            }

            if(trigger.hasAttribute('data-index') && current === +trigger.dataset.index) {
                isCurrent = true;
            }

            if(isDisabled) {
                trigger.setAttribute('disabled', '');
            } else {
                trigger.removeAttribute('disabled');
            }

            if(isCurrent) {
                trigger.setAttribute('data-current', '');
            } else {
                trigger.removeAttribute('data-current');
            }
        });
    };

    // Functie om alles opnieuw te initialiseren (handig voor responsive)
    const reinitialize = () => {
        checkNavigationNeeded();
        updateTriggerVisibility();

        if (navigationNeeded) {
            updateTriggerStates();
        }
    };

    // Initiële setup
    if(track.children.length > 0) {
        track.style.setProperty('--c', `${track.firstElementChild.clientWidth}px` || '');

        checkNavigationNeeded();
        updateTriggerVisibility();

        // Setup event listeners alleen als navigatie nodig is
        if (navigationNeeded) {
            triggers.forEach((trigger) => {
                if(trigger.hasAttribute('data-prev')) {
                    trigger.addEventListener('click', toPrevious);
                } else if(trigger.hasAttribute('data-next')) {
                    trigger.addEventListener('click', toNext);
                } else if(trigger.hasAttribute('data-index')) {
                    trigger.addEventListener('click', () => goToSlide(+trigger.dataset.index));
                }
            });

            track.addEventListener('touchstart', touchStartHandler, {passive: true});
            updateTriggerStates();
        }

        // Luister naar window resize voor responsive gedrag
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                track.style.setProperty('--c', `${track.firstElementChild.clientWidth}px` || '');
                reinitialize();
            }, 150);
        });

    } else {
        // Geen slides, verberg alle triggers
        triggers.forEach((trigger) => trigger.classList.add('d-none'));
    }
};

[...document.querySelectorAll('.js-slider')].map(initSlider);